module.exports = __webpack_public_path__ + "static/img/city_03.5324250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/city_03.png
// module id = ipyy
// module chunks = 0